import { render } from "./Internalcorrespondence.vue?vue&type=template&id=dc6ec1a4"
import script from "./Internalcorrespondence.vue?vue&type=script&lang=js"
export * from "./Internalcorrespondence.vue?vue&type=script&lang=js"

import exportComponent from "F:\\desktop2025\\UG_College_administration\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__